import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { SEO } from "@/components/common/SEO";
import SmartImage from "@/components/common/SmartImage";
import { Loader2, Star } from "lucide-react";

export default function Reviews() {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    api.get("/reviews?limit=40").then((r) => setRows(r.data)).finally(() => setBusy(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14" data-testid="reviews-page">
      <SEO title="Expert Car Reviews in India"
        description="Read TrendingNewCar's expert car reviews — real-world driving impressions, pros, cons and honest verdicts on every major car sold in India."
      />
      <div className="mb-10">
        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Editorial</div>
        <h1 className="font-display text-4xl sm:text-5xl mt-2 tracking-tighter">Expert reviews</h1>
        <p className="mt-3 text-muted-foreground max-w-2xl">Honest, real-world reviews with pros, cons and a clear verdict — never sponsored.</p>
      </div>
      {busy ? (
        <div className="grid place-items-center py-20 text-muted-foreground"><Loader2 className="w-5 h-5 animate-spin"/></div>
      ) : rows.length === 0 ? (
        <div className="text-center py-20 text-muted-foreground text-sm">No reviews published yet. Check back soon.</div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {rows.map((r) => (
            <Link key={r.slug} to={`/reviews/${r.slug}`} data-testid={`review-card-${r.slug}`}
              className="card-premium overflow-hidden group flex flex-col">
              {r.hero_image && (
                <div className="aspect-[16/9] overflow-hidden bg-[#F3F6FA]">
                  <SmartImage src={r.hero_image} alt={r.title} label={r.title} className="group-hover:scale-[1.05] transition-transform duration-700 ease-out"/>
                </div>
              )}
              <div className="p-5 flex-1 flex flex-col">
                <div className="flex items-center gap-1 text-amber-500 text-sm">
                  <Star className="w-4 h-4 fill-current"/> <span className="font-mono font-semibold">{Number(r.expert_rating).toFixed(1)}</span>
                  <span className="text-muted-foreground text-xs ml-1">/ 10</span>
                </div>
                <div className="font-display text-lg mt-2 tracking-tight leading-snug line-clamp-2">{r.title}</div>
                <p className="text-sm text-muted-foreground mt-2 line-clamp-3">{r.verdict}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
